import { FormField } from 'src/components/molecules/FormField'

import { FormFieldTypes } from 'src/types/form'

import { sectorTypeOptions } from '../../helper'

export const FarmingForestryRural = () => {
  return (
    <FormField
      id='Sector'
      label='Sector'
      options={sectorTypeOptions}
      type={FormFieldTypes.select}
    />
  )
}
